import axios from "axios";

// DVS-1739: queries go through the admin API, so the Sitecore API key never reaches the browser.
export const FetchData = async <T>(query: string):  Promise<T> => {
  try {
    const { data } = await axios.post<T>(
      `${process.env.REACT_APP_NOT_SECRET_SERVICE_URL}/webapi/adminreporting/graphql`,
      { query }
    );
    return data;

  } catch (error) {
    console.error("Error fetching survey data:", error);
    throw error;
  }
};
